// extracted by mini-css-extract-plugin
export default {"wrapper":"CatalogListItem_wrapper__VI40Q"};